/* eslint-disable */
// source: discount.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.billing.private.subscription.discount.AddCouponDiscountRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.AddCouponDiscountRequest.DiscountLengthCase', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.AddCouponDiscountResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.Coupon', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.DeductionType', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.Discount', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.Discount.DiscountModelCase', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.Discount.MonetaryModel', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.Discount.PercentageModel', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.DiscountType', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.FrequencyType', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.GetDiscountsRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.GetDiscountsResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.RemoveDiscountRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.RemoveDiscountResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.SubscriptionDiscount', null, global);
goog.exportSymbol('proto.billing.private.subscription.discount.SubscriptionDiscount.CouponCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.billing.private.subscription.discount.AddCouponDiscountRequest.oneofGroups_);
};
goog.inherits(proto.billing.private.subscription.discount.AddCouponDiscountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.AddCouponDiscountRequest.displayName = 'proto.billing.private.subscription.discount.AddCouponDiscountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.displayName = 'proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.discount.AddCouponDiscountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.AddCouponDiscountResponse.displayName = 'proto.billing.private.subscription.discount.AddCouponDiscountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.discount.RemoveDiscountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.RemoveDiscountRequest.displayName = 'proto.billing.private.subscription.discount.RemoveDiscountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.discount.RemoveDiscountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.RemoveDiscountResponse.displayName = 'proto.billing.private.subscription.discount.RemoveDiscountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.GetDiscountsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.discount.GetDiscountsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.GetDiscountsRequest.displayName = 'proto.billing.private.subscription.discount.GetDiscountsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.GetDiscountsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.discount.GetDiscountsResponse.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.discount.GetDiscountsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.GetDiscountsResponse.displayName = 'proto.billing.private.subscription.discount.GetDiscountsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.SubscriptionDiscount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.billing.private.subscription.discount.SubscriptionDiscount.oneofGroups_);
};
goog.inherits(proto.billing.private.subscription.discount.SubscriptionDiscount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.SubscriptionDiscount.displayName = 'proto.billing.private.subscription.discount.SubscriptionDiscount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.Coupon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.discount.Coupon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.Coupon.displayName = 'proto.billing.private.subscription.discount.Coupon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.Discount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.billing.private.subscription.discount.Discount.oneofGroups_);
};
goog.inherits(proto.billing.private.subscription.discount.Discount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.Discount.displayName = 'proto.billing.private.subscription.discount.Discount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.Discount.PercentageModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.discount.Discount.PercentageModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.Discount.PercentageModel.displayName = 'proto.billing.private.subscription.discount.Discount.PercentageModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.discount.Discount.MonetaryModel.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.discount.Discount.MonetaryModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.Discount.MonetaryModel.displayName = 'proto.billing.private.subscription.discount.Discount.MonetaryModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.displayName = 'proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.oneofGroups_ = [[5,6]];

/**
 * @enum {number}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.DiscountLengthCase = {
  DISCOUNT_LENGTH_NOT_SET: 0,
  IS_LIFETIME: 5,
  FIXED_TERM: 6
};

/**
 * @return {proto.billing.private.subscription.discount.AddCouponDiscountRequest.DiscountLengthCase}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.getDiscountLengthCase = function() {
  return /** @type {proto.billing.private.subscription.discount.AddCouponDiscountRequest.DiscountLengthCase} */(jspb.Message.computeOneofCase(this, proto.billing.private.subscription.discount.AddCouponDiscountRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.AddCouponDiscountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    discountId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestedByUserId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isLifetime: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    fixedTerm: (f = msg.getFixedTerm()) && proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.AddCouponDiscountRequest;
  return proto.billing.private.subscription.discount.AddCouponDiscountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscountId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestedByUserId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLifetime(value);
      break;
    case 6:
      var value = new proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength;
      reader.readMessage(value,proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.deserializeBinaryFromReader);
      msg.setFixedTerm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.AddCouponDiscountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDiscountId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRequestedByUserId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getFixedTerm();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.toObject = function(includeInstance, msg) {
  var f, obj = {
    frequency: jspb.Message.getFieldWithDefault(msg, 1, 0),
    frequencyType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength;
  return proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrequency(value);
      break;
    case 2:
      var value = /** @type {!proto.billing.private.subscription.discount.FrequencyType} */ (reader.readEnum());
      msg.setFrequencyType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrequency();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFrequencyType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int32 frequency = 1;
 * @return {number}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.prototype.getFrequency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.prototype.setFrequency = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional FrequencyType frequency_type = 2;
 * @return {!proto.billing.private.subscription.discount.FrequencyType}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.prototype.getFrequencyType = function() {
  return /** @type {!proto.billing.private.subscription.discount.FrequencyType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.billing.private.subscription.discount.FrequencyType} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength.prototype.setFrequencyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 discount_id = 3;
 * @return {number}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.getDiscountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.setDiscountId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 requested_by_user_id = 4;
 * @return {number}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.getRequestedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.setRequestedByUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_lifetime = 5;
 * @return {boolean}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.getIsLifetime = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.setIsLifetime = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.billing.private.subscription.discount.AddCouponDiscountRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.clearIsLifetime = function() {
  return jspb.Message.setOneofField(this, 5, proto.billing.private.subscription.discount.AddCouponDiscountRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.hasIsLifetime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional FixedTermDiscountLength fixed_term = 6;
 * @return {?proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.getFixedTerm = function() {
  return /** @type{?proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength, 6));
};


/**
 * @param {?proto.billing.private.subscription.discount.AddCouponDiscountRequest.FixedTermDiscountLength|undefined} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} returns this
*/
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.setFixedTerm = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.billing.private.subscription.discount.AddCouponDiscountRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.clearFixedTerm = function() {
  return this.setFixedTerm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.AddCouponDiscountRequest.prototype.hasFixedTerm = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.AddCouponDiscountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountResponse}
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.AddCouponDiscountResponse;
  return proto.billing.private.subscription.discount.AddCouponDiscountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountResponse}
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.AddCouponDiscountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.AddCouponDiscountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.discount.AddCouponDiscountResponse} returns this
 */
proto.billing.private.subscription.discount.AddCouponDiscountResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.RemoveDiscountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.RemoveDiscountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    subscriptionDiscountId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestedByUserId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountRequest}
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.RemoveDiscountRequest;
  return proto.billing.private.subscription.discount.RemoveDiscountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.RemoveDiscountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountRequest}
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionDiscountId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestedByUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.RemoveDiscountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.RemoveDiscountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSubscriptionDiscountId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRequestedByUserId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 subscription_discount_id = 3;
 * @return {number}
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.getSubscriptionDiscountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.setSubscriptionDiscountId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 requested_by_user_id = 4;
 * @return {number}
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.getRequestedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountRequest} returns this
 */
proto.billing.private.subscription.discount.RemoveDiscountRequest.prototype.setRequestedByUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.RemoveDiscountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.RemoveDiscountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountResponse}
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.RemoveDiscountResponse;
  return proto.billing.private.subscription.discount.RemoveDiscountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.RemoveDiscountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountResponse}
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.RemoveDiscountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.RemoveDiscountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.discount.RemoveDiscountResponse} returns this
 */
proto.billing.private.subscription.discount.RemoveDiscountResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.GetDiscountsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.GetDiscountsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.GetDiscountsRequest}
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.GetDiscountsRequest;
  return proto.billing.private.subscription.discount.GetDiscountsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.GetDiscountsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.GetDiscountsRequest}
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.GetDiscountsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.GetDiscountsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.GetDiscountsRequest} returns this
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.GetDiscountsRequest} returns this
 */
proto.billing.private.subscription.discount.GetDiscountsRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.GetDiscountsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.GetDiscountsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    discountsList: jspb.Message.toObjectList(msg.getDiscountsList(),
    proto.billing.private.subscription.discount.SubscriptionDiscount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.GetDiscountsResponse}
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.GetDiscountsResponse;
  return proto.billing.private.subscription.discount.GetDiscountsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.GetDiscountsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.GetDiscountsResponse}
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billing.private.subscription.discount.SubscriptionDiscount;
      reader.readMessage(value,proto.billing.private.subscription.discount.SubscriptionDiscount.deserializeBinaryFromReader);
      msg.addDiscounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.GetDiscountsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.GetDiscountsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billing.private.subscription.discount.SubscriptionDiscount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionDiscount discounts = 1;
 * @return {!Array<!proto.billing.private.subscription.discount.SubscriptionDiscount>}
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.prototype.getDiscountsList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.discount.SubscriptionDiscount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.discount.SubscriptionDiscount, 1));
};


/**
 * @param {!Array<!proto.billing.private.subscription.discount.SubscriptionDiscount>} value
 * @return {!proto.billing.private.subscription.discount.GetDiscountsResponse} returns this
*/
proto.billing.private.subscription.discount.GetDiscountsResponse.prototype.setDiscountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billing.private.subscription.discount.SubscriptionDiscount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount}
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.prototype.addDiscounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing.private.subscription.discount.SubscriptionDiscount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.discount.GetDiscountsResponse} returns this
 */
proto.billing.private.subscription.discount.GetDiscountsResponse.prototype.clearDiscountsList = function() {
  return this.setDiscountsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.CouponCase = {
  COUPON_NOT_SET: 0,
  NO_COUPON: 4,
  COUPON_VALUE: 5
};

/**
 * @return {proto.billing.private.subscription.discount.SubscriptionDiscount.CouponCase}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getCouponCase = function() {
  return /** @type {proto.billing.private.subscription.discount.SubscriptionDiscount.CouponCase} */(jspb.Message.computeOneofCase(this, proto.billing.private.subscription.discount.SubscriptionDiscount.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.SubscriptionDiscount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.SubscriptionDiscount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscriptionDiscountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    discount: (f = msg.getDiscount()) && proto.billing.private.subscription.discount.Discount.toObject(includeInstance, f),
    planId: (f = msg.getPlanId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    noCoupon: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    couponValue: (f = msg.getCouponValue()) && proto.billing.private.subscription.discount.Coupon.toObject(includeInstance, f),
    isRetentionDiscount: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    addedOn: (f = msg.getAddedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    expiresOn: (f = msg.getExpiresOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.SubscriptionDiscount;
  return proto.billing.private.subscription.discount.SubscriptionDiscount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.SubscriptionDiscount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionDiscountId(value);
      break;
    case 2:
      var value = new proto.billing.private.subscription.discount.Discount;
      reader.readMessage(value,proto.billing.private.subscription.discount.Discount.deserializeBinaryFromReader);
      msg.setDiscount(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPlanId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNoCoupon(value);
      break;
    case 5:
      var value = new proto.billing.private.subscription.discount.Coupon;
      reader.readMessage(value,proto.billing.private.subscription.discount.Coupon.deserializeBinaryFromReader);
      msg.setCouponValue(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRetentionDiscount(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAddedOn(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiresOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.SubscriptionDiscount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.SubscriptionDiscount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionDiscountId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDiscount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.billing.private.subscription.discount.Discount.serializeBinaryToWriter
    );
  }
  f = message.getPlanId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCouponValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.billing.private.subscription.discount.Coupon.serializeBinaryToWriter
    );
  }
  f = message.getIsRetentionDiscount();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAddedOn();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExpiresOn();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 subscription_discount_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getSubscriptionDiscountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.setSubscriptionDiscountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Discount discount = 2;
 * @return {?proto.billing.private.subscription.discount.Discount}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getDiscount = function() {
  return /** @type{?proto.billing.private.subscription.discount.Discount} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.subscription.discount.Discount, 2));
};


/**
 * @param {?proto.billing.private.subscription.discount.Discount|undefined} value
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
*/
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.setDiscount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.clearDiscount = function() {
  return this.setDiscount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.hasDiscount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value plan_id = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getPlanId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
*/
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.setPlanId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.clearPlanId = function() {
  return this.setPlanId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.hasPlanId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool no_coupon = 4;
 * @return {boolean}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getNoCoupon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.setNoCoupon = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.billing.private.subscription.discount.SubscriptionDiscount.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.clearNoCoupon = function() {
  return jspb.Message.setOneofField(this, 4, proto.billing.private.subscription.discount.SubscriptionDiscount.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.hasNoCoupon = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Coupon coupon_value = 5;
 * @return {?proto.billing.private.subscription.discount.Coupon}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getCouponValue = function() {
  return /** @type{?proto.billing.private.subscription.discount.Coupon} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.subscription.discount.Coupon, 5));
};


/**
 * @param {?proto.billing.private.subscription.discount.Coupon|undefined} value
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
*/
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.setCouponValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.billing.private.subscription.discount.SubscriptionDiscount.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.clearCouponValue = function() {
  return this.setCouponValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.hasCouponValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool is_retention_discount = 6;
 * @return {boolean}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getIsRetentionDiscount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.setIsRetentionDiscount = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp added_on = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getAddedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
*/
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.setAddedOn = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.clearAddedOn = function() {
  return this.setAddedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.hasAddedOn = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp expires_on = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.getExpiresOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
*/
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.setExpiresOn = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.discount.SubscriptionDiscount} returns this
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.clearExpiresOn = function() {
  return this.setExpiresOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.SubscriptionDiscount.prototype.hasExpiresOn = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.Coupon.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.Coupon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.Coupon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Coupon.toObject = function(includeInstance, msg) {
  var f, obj = {
    couponId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.Coupon}
 */
proto.billing.private.subscription.discount.Coupon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.Coupon;
  return proto.billing.private.subscription.discount.Coupon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.Coupon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.Coupon}
 */
proto.billing.private.subscription.discount.Coupon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCouponId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.Coupon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.Coupon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.Coupon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Coupon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCouponId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 coupon_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.discount.Coupon.prototype.getCouponId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.Coupon} returns this
 */
proto.billing.private.subscription.discount.Coupon.prototype.setCouponId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billing.private.subscription.discount.Coupon.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.discount.Coupon} returns this
 */
proto.billing.private.subscription.discount.Coupon.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.billing.private.subscription.discount.Discount.oneofGroups_ = [[5,6]];

/**
 * @enum {number}
 */
proto.billing.private.subscription.discount.Discount.DiscountModelCase = {
  DISCOUNT_MODEL_NOT_SET: 0,
  PERCENTAGE: 5,
  MONETARY: 6
};

/**
 * @return {proto.billing.private.subscription.discount.Discount.DiscountModelCase}
 */
proto.billing.private.subscription.discount.Discount.prototype.getDiscountModelCase = function() {
  return /** @type {proto.billing.private.subscription.discount.Discount.DiscountModelCase} */(jspb.Message.computeOneofCase(this, proto.billing.private.subscription.discount.Discount.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.Discount.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.Discount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.Discount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Discount.toObject = function(includeInstance, msg) {
  var f, obj = {
    discountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    discountUniqueId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    discountType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    percentage: (f = msg.getPercentage()) && proto.billing.private.subscription.discount.Discount.PercentageModel.toObject(includeInstance, f),
    monetary: (f = msg.getMonetary()) && proto.billing.private.subscription.discount.Discount.MonetaryModel.toObject(includeInstance, f),
    deductionType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    isAllowedWithOtherDiscounts: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.Discount}
 */
proto.billing.private.subscription.discount.Discount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.Discount;
  return proto.billing.private.subscription.discount.Discount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.Discount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.Discount}
 */
proto.billing.private.subscription.discount.Discount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscountUniqueId(value);
      break;
    case 4:
      var value = /** @type {!proto.billing.private.subscription.discount.DiscountType} */ (reader.readEnum());
      msg.setDiscountType(value);
      break;
    case 5:
      var value = new proto.billing.private.subscription.discount.Discount.PercentageModel;
      reader.readMessage(value,proto.billing.private.subscription.discount.Discount.PercentageModel.deserializeBinaryFromReader);
      msg.setPercentage(value);
      break;
    case 6:
      var value = new proto.billing.private.subscription.discount.Discount.MonetaryModel;
      reader.readMessage(value,proto.billing.private.subscription.discount.Discount.MonetaryModel.deserializeBinaryFromReader);
      msg.setMonetary(value);
      break;
    case 7:
      var value = /** @type {!proto.billing.private.subscription.discount.DeductionType} */ (reader.readEnum());
      msg.setDeductionType(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAllowedWithOtherDiscounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.Discount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.Discount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.Discount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Discount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscountId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDiscountUniqueId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDiscountType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPercentage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.billing.private.subscription.discount.Discount.PercentageModel.serializeBinaryToWriter
    );
  }
  f = message.getMonetary();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.billing.private.subscription.discount.Discount.MonetaryModel.serializeBinaryToWriter
    );
  }
  f = message.getDeductionType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getIsAllowedWithOtherDiscounts();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.Discount.PercentageModel.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.Discount.PercentageModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.Discount.PercentageModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Discount.PercentageModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    percentage: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.Discount.PercentageModel}
 */
proto.billing.private.subscription.discount.Discount.PercentageModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.Discount.PercentageModel;
  return proto.billing.private.subscription.discount.Discount.PercentageModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.Discount.PercentageModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.Discount.PercentageModel}
 */
proto.billing.private.subscription.discount.Discount.PercentageModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.Discount.PercentageModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.Discount.PercentageModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.Discount.PercentageModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Discount.PercentageModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercentage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 percentage = 1;
 * @return {number}
 */
proto.billing.private.subscription.discount.Discount.PercentageModel.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.Discount.PercentageModel} returns this
 */
proto.billing.private.subscription.discount.Discount.PercentageModel.prototype.setPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.Discount.MonetaryModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.Discount.MonetaryModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    pricesList: jspb.Message.toObjectList(msg.getPricesList(),
    proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.Discount.MonetaryModel;
  return proto.billing.private.subscription.discount.Discount.MonetaryModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.Discount.MonetaryModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices;
      reader.readMessage(value,proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.deserializeBinaryFromReader);
      msg.addPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.Discount.MonetaryModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.Discount.MonetaryModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.toObject = function(includeInstance, msg) {
  var f, obj = {
    currencyCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0),
    valueFormatted: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices;
  return proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValueFormatted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getValueFormatted();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string currency_code = 1;
 * @return {string}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices} returns this
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 value = 2;
 * @return {number}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices} returns this
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string value_formatted = 3;
 * @return {string}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.prototype.getValueFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices} returns this
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices.prototype.setValueFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated MonetaryCurrencyPrices prices = 1;
 * @return {!Array<!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices>}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.prototype.getPricesList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices, 1));
};


/**
 * @param {!Array<!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices>} value
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel} returns this
*/
proto.billing.private.subscription.discount.Discount.MonetaryModel.prototype.setPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices}
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.prototype.addPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing.private.subscription.discount.Discount.MonetaryModel.MonetaryCurrencyPrices, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.discount.Discount.MonetaryModel} returns this
 */
proto.billing.private.subscription.discount.Discount.MonetaryModel.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};


/**
 * optional int32 discount_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.discount.Discount.prototype.getDiscountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
 */
proto.billing.private.subscription.discount.Discount.prototype.setDiscountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billing.private.subscription.discount.Discount.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
 */
proto.billing.private.subscription.discount.Discount.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string discount_unique_id = 3;
 * @return {string}
 */
proto.billing.private.subscription.discount.Discount.prototype.getDiscountUniqueId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
 */
proto.billing.private.subscription.discount.Discount.prototype.setDiscountUniqueId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional DiscountType discount_type = 4;
 * @return {!proto.billing.private.subscription.discount.DiscountType}
 */
proto.billing.private.subscription.discount.Discount.prototype.getDiscountType = function() {
  return /** @type {!proto.billing.private.subscription.discount.DiscountType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.billing.private.subscription.discount.DiscountType} value
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
 */
proto.billing.private.subscription.discount.Discount.prototype.setDiscountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional PercentageModel percentage = 5;
 * @return {?proto.billing.private.subscription.discount.Discount.PercentageModel}
 */
proto.billing.private.subscription.discount.Discount.prototype.getPercentage = function() {
  return /** @type{?proto.billing.private.subscription.discount.Discount.PercentageModel} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.subscription.discount.Discount.PercentageModel, 5));
};


/**
 * @param {?proto.billing.private.subscription.discount.Discount.PercentageModel|undefined} value
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
*/
proto.billing.private.subscription.discount.Discount.prototype.setPercentage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.billing.private.subscription.discount.Discount.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
 */
proto.billing.private.subscription.discount.Discount.prototype.clearPercentage = function() {
  return this.setPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.Discount.prototype.hasPercentage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MonetaryModel monetary = 6;
 * @return {?proto.billing.private.subscription.discount.Discount.MonetaryModel}
 */
proto.billing.private.subscription.discount.Discount.prototype.getMonetary = function() {
  return /** @type{?proto.billing.private.subscription.discount.Discount.MonetaryModel} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.subscription.discount.Discount.MonetaryModel, 6));
};


/**
 * @param {?proto.billing.private.subscription.discount.Discount.MonetaryModel|undefined} value
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
*/
proto.billing.private.subscription.discount.Discount.prototype.setMonetary = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.billing.private.subscription.discount.Discount.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
 */
proto.billing.private.subscription.discount.Discount.prototype.clearMonetary = function() {
  return this.setMonetary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.discount.Discount.prototype.hasMonetary = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional DeductionType deduction_type = 7;
 * @return {!proto.billing.private.subscription.discount.DeductionType}
 */
proto.billing.private.subscription.discount.Discount.prototype.getDeductionType = function() {
  return /** @type {!proto.billing.private.subscription.discount.DeductionType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.billing.private.subscription.discount.DeductionType} value
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
 */
proto.billing.private.subscription.discount.Discount.prototype.setDeductionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional bool is_allowed_with_other_discounts = 8;
 * @return {boolean}
 */
proto.billing.private.subscription.discount.Discount.prototype.getIsAllowedWithOtherDiscounts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.discount.Discount} returns this
 */
proto.billing.private.subscription.discount.Discount.prototype.setIsAllowedWithOtherDiscounts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * @enum {number}
 */
proto.billing.private.subscription.discount.DiscountType = {
  UNSPECIFIED_DIT: 0,
  PERCENTAGE: 1,
  MONETARY: 2
};

/**
 * @enum {number}
 */
proto.billing.private.subscription.discount.FrequencyType = {
  UNSPECIFIED_FT: 0,
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3,
  YEARLY: 4
};

/**
 * @enum {number}
 */
proto.billing.private.subscription.discount.DeductionType = {
  UNSPECIFIED_DET: 0,
  PLAN_ONLY: 1,
  ENTIRE_SUBSCRIPTION: 2
};

goog.object.extend(exports, proto.billing.private.subscription.discount);
